const initialState = {job: {}}

export const job = (state = initialState, action) => {
	switch (action.type) {
  	case 'SET_JOB':
      return {job: action.payload}; 
  }
  return state
}


